import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "انتشار موزیک چقدر هزینه دارد؟", a: "ما دو راهکار اصلی برای انتشار داریم: پلن «تازه کارها» که کاملاً رایگان ($0) است و پلن «حرفه ای ها» که به صورت سالانه ۲۵ دلار هزینه دارد. در تمامی پلن‌ها، تعداد انتشار موزیک شما کاملاً نامحدود است و تفاوت اصلی این روش‌ها در مدت زمان انتظار برای انتشار موزیک‌هاست." },
  { q: "انتشار موزیک‌ویدیو چقدر هزینه دارد؟", a: "هزینه انتشار موزیک‌ویدیو ۱۲۰ دلار به‌صورت سالانه است." },
  { q: "کارمزد نقد کردن درآمد چقدر است؟", a: "کارمزد نقد کردن درآمد ۲۵ درصد از مبلغ دریافتی است. پس از کسر کارمزد، سهم هنرمند با بالاترین نرخ ارز قابل پرداخت در ایران تسویه می‌شود." },
  { q: "آیا برای دریافت درآمد نیاز به حساب خارجی دارم؟", a: "خیر. هدف این سرویس این است که هنرمندان ایرانی بدون نیاز به حساب بانکی خارجی بتوانند درآمد پلتفرم‌های بین‌المللی را در ایران دریافت کنند." },
  { q: "آیا مالکیت آهنگ برای خودم می‌ماند؟", a: "بله، مالکیت هنری اثر متعلق به صاحب اثر باقی می‌ماند. ما فرآیند انتشار، مدیریت درآمد، لایسنس و پیگیری حقوق اثر را انجام می‌دهیم." },
  { q: "موزیک در چه پلتفرم‌هایی منتشر می‌شود؟", a: "آثار شما می‌تواند در پلتفرم‌هایی مانند Spotify، Apple Music، YouTube Music، YouTube، TikTok، Instagram Music، Deezer، Amazon Music، Tidal، Shazam و سایر سرویس‌های بین‌المللی منتشر شود." },
  { q: "انتشار موزیک چقدر زمان می‌برد؟", a: "زمان انتشار بستگی به پلن انتخابی شما دارد؛ در پلن رایگان (تازه کارها) زمان انتظار برای انتشار آثار ۳ هفته است، در حالی که در پلن ۲۵ دلاری (حرفه ای ها) فرآیند بررسی و پخش در اولویت قرار گرفته و تنها ۷۲ ساعت زمان می‌برد." },
  { q: "آیا درآمد موزیک تضمینی است؟", a: "خیر. درآمد موسیقی به تعداد استریم، کشور مخاطبان، نوع پلتفرم، قوانین پرداخت و عملکرد واقعی اثر بستگی دارد. ما درآمد قطعی را تضمین نمی‌کنیم، اما مسیر انتشار و دریافت درآمد را برای شما مدیریت می‌کنیم." },
  { q: "اگر کسی بدون اجازه از موزیک من استفاده کند چه می‌شود؟", a: "در صورت استفاده غیرمجاز، موضوع بررسی می‌شود و بسته به قوانین پلتفرم مربوطه، امکان ثبت Claim، گزارش تخلف یا درخواست حذف محتوا وجود دارد." },
  { q: "آیا آهنگ کاور، ریمیکس یا بیت خریداری‌شده هم قابل انتشار است؟", a: "این موارد نیاز به بررسی حقوقی و مالکیتی دارند. اگر مجوزهای لازم، لایسنس بیت، اجازه صاحب اثر یا مدارک مالکیت وجود داشته باشد، امکان بررسی و انتشار وجود دارد." },
  { q: "برای انتشار موزیک چه فایل‌هایی لازم است؟", a: "معمولاً فایل نهایی موزیک با کیفیت مناسب، کاور استاندارد، نام هنرمند، نام اثر، اطلاعات صاحب اثر، تاریخ انتشار و توضیحات مربوط به مالکیت لازم است." },
  { q: "آیا امکان انتشار آلبوم هم وجود دارد؟", a: "بله. علاوه بر تک‌آهنگ، امکان بررسی و انتشار EP یا آلبوم نیز وجود دارد." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28 relative">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            سوالات <span className="gradient-text-neon">متداول</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="glass rounded-2xl px-5 border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-right text-base font-semibold hover:no-underline py-5 [&>svg]:text-cyan-300">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-300 text-sm leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
